import { useMemo, useState } from 'react';
import { SelectItemType } from '@/types';

export const useCoverageSearch = (items: SelectItemType[], selectedValues: string[]) => {
  const [searchValue, setSearchValue] = useState('');

  const filteredItems = useMemo(() => {
    if (!searchValue) return items;
    const lower = searchValue.toLowerCase();
    return items.filter((item) => selectedValues.includes(item.value) || item.name.toLowerCase().includes(lower));
  }, [items, searchValue, selectedValues]);

  return { searchValue, setSearchValue, filteredItems };
};
